/*=============================
=          Accordion          =
=============================*/

[].slice.call(document.querySelectorAll('.accordion-button')).forEach(function(accordion) {
	accordion.addEventListener('click', toggleAccordion);
});

function toggleAccordion() {
	// var openAccordion = this.parentElement.parentElement.querySelector('.open'),
	// 	isLocations = this.parentNode.parentNode.classList.contains('accordion-locations');

	// if(!isLocations && openAccordion && openAccordion !== this)
	// 	toggleAccordionDisplay(openAccordion, false);

	if(this.parentNode.classList.contains('region-accordion') ? checkWidth(768) : true) {
		var isOpening = !this.classList.contains('open');

		if(isOpening) {
			document.querySelectorAll('.accordion-button.open').forEach(function(btn) {
				if(btn !== this)
					toggleAccordionDisplay(btn, false);
			}.bind(this));
		}

		toggleAccordionDisplay(this, isOpening);
	}

	// if(isLocations)
	// 	setTimeout(function() {
	// 		scrollToElement(answer.parentNode);
	// 	}, 250);
}

window.toggleAccordionDisplay = function toggleAccordionDisplay(el, open) {
	Velocity(el.nextSibling, (open ? 'slideDown' : 'slideUp'), {duration: 250});

	if(open) {
		el.classList.add('open');
	} else {
		el.classList.remove('open');
	}

	el.setAttribute('aria-expanded', (open ? 'true' : 'false'));
};

/*=============================
=       Lazy Load Images      =
=============================*/

window.imgLazyload = function imgLazyload(img) {
	img.src = img.dataset.src;
	img.classList.add('loaded');
};

window.bgLazyLoad = function bgLazyLoad(el) {
	if (!el || el.classList.contains('loaded')) return;

	const src =
		window.innerWidth <= 768 && el.dataset.srcMobile
			? el.dataset.srcMobile
			: el.dataset.src;

	if (!src) return;

	if (el.tagName === 'IMG') {
		el.src = src;
	} else {
		el.style.backgroundImage = `url('${src}')`;
	}

	el.classList.add('loaded');
};

var heroImages = [].slice.call(document.querySelectorAll('#hero .bg-container')),
	lazyElements = [].slice.call(document.querySelectorAll('main img:not(.not-lazy):not(.first), .bg-container:not(.first), footer img, main video[data-src]:not([src])')),
	active = false;

var heroLazyLoad = function() {};

var lazyLoad = function() {
	if (active === false) {
		active = true;

		setTimeout(function() {
			lazyElements.forEach(function(el) {
				if ((el.getBoundingClientRect().top <= (window.innerHeight + 300) && el.getBoundingClientRect().bottom >= 0) && getComputedStyle(el).display !== 'none') {
					if (el.classList.contains('bg-container'))
						bgLazyLoad(el);
					else if (el.tagName === 'IMG')
						imgLazyload(el);

					lazyElements = lazyElements.filter(function(image) {
						return image !== el;
					});

					if (lazyElements.length === 0) {
						document.removeEventListener('scroll', lazyLoad);
						window.removeEventListener('resize', lazyLoad);
						window.removeEventListener('orientationchange', lazyLoad);
					}
				}
			});

			active = false;
		}, 200);
	}
};

document.addEventListener('scroll', lazyLoad);
window.addEventListener('resize', heroLazyLoad);
window.addEventListener('resize', lazyLoad);
window.addEventListener('orientationchange', heroLazyLoad);
window.addEventListener('orientationchange', lazyLoad);

window.addEventListener('resize', function() {
	setTimeout(function() {
		[].slice.call(document.querySelectorAll('.loaded[data-src-mobile]')).forEach(function(img) {
			bgLazyLoad(img);
		});
	}, 300);
});

/*=============================
=        Announcements        =
=============================*/

if(topbar) {
	var announcementButtons = [].slice.call(topbar.querySelectorAll('button')),
		firstAnnouncement = topbar.querySelector('li:first-child'),
		lastAnnouncement = topbar.querySelector('li:last-child'),
		autoSlide = function() {
			slideAnnouncement('next');
		};

	if(announcementButtons.length)
		var intervalID = setInterval(autoSlide, 15000);

	announcementButtons.forEach(function(button) {
		button.addEventListener('click', function() {
			clearInterval(intervalID);
			slideAnnouncement(this.className);
		});
	});
}

document.addEventListener('keydown', function(e) {
	if(announcementButtons && announcementButtons.includes(document.activeElement)) {
		var direction = e.key == 'ArrowRight' ? 'next' : 'prev';

		topbar.querySelector('button.'+direction).focus();
		clearInterval(intervalID);
		slideAnnouncement(direction);
	}
});

function slideAnnouncement(direction) {
	var current = topbar.querySelector('.current'),
		sibling = direction == 'next' ? (current == lastAnnouncement ? firstAnnouncement : current.nextSibling) : (current == firstAnnouncement ? lastAnnouncement : current.previousSibling);

	current.classList.add('hide');
	sibling.classList.add('current', 'hide', direction);

	setTimeout(function() {
		current.className = '';
		sibling.classList.remove('hide', direction);
	}, 550);
}

/*=============================
=         Sticky Header       =
=============================*/

if(hero) {
	if(body.id === 'giveaway' || body.id === 'giveaway-spanish') {
		var stickyOffset = body.classList.contains('mobile') ? 40 : 160;
		var lastScrollTop = 0;

		window.addEventListener('scroll', function() {
			var st = window.pageYOffset || document.documentElement.scrollTop || 0;

			if(st >= stickyOffset)
				body.classList.add('sticky');
			else
				body.classList.remove('sticky');

			if(checkWidth(480) && body.classList.contains('sticky') && topbar) {
				if(st > lastScrollTop)
					topbar.classList.add('hide');
				else
					topbar.classList.remove('hide');
			}

			lastScrollTop = st <= 0 ? 0 : st;
		});
	} else {
		var stickyHeader = new Waypoint({
			element: hero.querySelector('.container'),
			handler: function(direction) {
				var down = direction == 'down';
				if(down)
					body.classList.add('sticky');
				else
					body.classList.remove('sticky');
			},
			offset: body.classList.contains('location-new') ? 100 : 160
		});

		var lastScrollTop = 0;
		window.addEventListener('scroll', function() {
			if(checkWidth(480) && body.classList.contains('sticky') && topbar) {
				var st = window.pageYOffset || document.documentElement.scrollTop;
				if(st > lastScrollTop)
					topbar.classList.add('hide');
				else
					topbar.classList.remove('hide');
				lastScrollTop = st <= 0 ? 0 : st;
			}
		});
	}
}

/*=============================
=             Menu            =
=============================*/

var menuButton = document.getElementById('menu-button'),
	mobileMenu = document.getElementById('mobile-menu-container'),
	desktopMenu = mobileMenu ? mobileMenu.querySelector('.secondary-menu') : false;

body.addEventListener('click', function(e) {
	checkAndCloseMenu(e.target);
});

document.addEventListener('keydown', function(e) {
	if(e.key == 'Escape')
		checkAndCloseMenu(mobileMenu);
});

function checkAndCloseMenu(e) {
	var open = openMenu(e);

	if(open) {
		closeMenu(open);
		toggleMenuBodyClass(false);
	}
}

[].slice.call(document.querySelectorAll('#menu-button, #mobile-menu-container button')).forEach(function(navLink) {
	navLink.addEventListener('click', toggleMenu);
});

function toggleMenu() {
	closeMenu(openMenu(this));

	var isMenuButton = this == menuButton,
		parent = this.parentNode.parentNode,
		isOpen = this.classList.contains('open'),
		openSibling = parent.querySelector('.open');

	if(parent.classList.contains('submenu') && openSibling && openSibling != this)
		closeMenu(openSibling);

	if(isMenuButton && !checkWidth(1200)) {
		Velocity(this.nextElementSibling, {opacity: isOpen ? [0, 1] : [1, 0]}, {duration: 300, display: isOpen ? 'none' : 'block'});
		Velocity(desktopMenu, {translateX: isOpen ? ['17.9375rem', 0] : [0, '17.9375rem']}, {duration: 300});
	}
	else
		Velocity(this.nextElementSibling, (isOpen ? 'slideUp' : 'slideDown'), {duration: isMenuButton ? 300 : 150});

	this.classList.toggle('open');

	this.setAttribute('aria-expanded', (this.getAttribute('aria-expanded') == 'true' ? 'false' : 'true'));

	toggleMenuBodyClass(header.querySelector('.open'));
}

function closeMenu(el) {
	if(el) {
		var submenu = el.nextElementSibling;

		if(el == menuButton && !checkWidth(768)) {
			Velocity(submenu, {opacity: [0, 1]}, {duration: 300, display: 'none'});
			Velocity(desktopMenu, {translateX: ['17.9375rem', 0]}, {duration: 300});
		}
		else
			Velocity(submenu, 'slideUp', {duration: el == menuButton ? 300 : 150});

		el.classList.remove('open');

		closeMenu(submenu.querySelector('.open'));
	}
}

function openMenu(el) {
	var openButton = header.querySelector('.open');

	if(openButton && !checkWidth(768) && el == mobileMenu && !desktopMenu.contains(el))
		return openButton;

	return openButton && !openButton.parentNode.contains(el) && el != menuButton ? openButton : false;
}

function toggleMenuBodyClass(open) {
	if(open)
		body.classList.add('menu-open');
	else
		body.classList.remove('menu-open');

	setFocus((open ? true : false), header);
}

if(mobileMenu) {
	mobileMenu.addEventListener('scroll', function() {
		if(checkWidth(768) && body.classList.contains('menu-open')) {
			var st = this.scrollTop;

			if(st > 0)
				body.classList.add('menu-scrolled');
			else
				body.classList.remove('menu-scrolled');
		}
	});
}

function setFocus(open, container) {
	[].slice.call(document.querySelectorAll('#header, #hero, #main, #newsletter, #footer')).forEach(function(parent) {
		if(parent != container) {
			parent.setAttribute('aria-hidden', open);

			[].slice.call(parent.querySelectorAll('a, button, input')).forEach(function(link) {
				if(open)
					link.setAttribute('tabindex', '-1');
				else
					link.removeAttribute('tabindex');
			});
		}
	});
}

/*=============================
=        Skip to Content      =
=============================*/

var skipLink = document.getElementById('skip-link');

skipLink.addEventListener('click', function(e) {
	e.preventDefault();

	var firstLink = document.querySelector('#hero a, main a');

	if(firstLink) {
		scrollToElement(firstLink);
		firstLink.focus();
	}
});

function skipLinkToggleDisplay(hide) {
	skipLink.style.display = hide ? 'none' : '';
}

/*=============================
=        Scroll To Link       =
=============================*/

var landingLink = document.querySelectorAll('.landing-link');

if(landingLink.length > 0) {
	landingLink[0].style.display = 'block';

	window.addEventListener('scroll', () => {	
		if (window.scrollY > 0) {
			landingLink[0].style.display = 'none';
		} else {
			landingLink[0].style.display = 'block';
		}
	});
};


if(!document.getElementById('landing')) {
	var scrollLinks = [].slice.call(document.querySelectorAll('.scroll-link'));

	scrollLinks.forEach(function(scrollLink) {
		scrollLink.addEventListener('click', function(e) {
			if(this.tagName == 'A')
				e.preventDefault();

			const url = new URL(this.href);
			const hash = url.hash;

			if(!hash || hash === '#')
				return;

			const targetElem = document.querySelector(hash);

			if(targetElem) {
				scrollToElement(targetElem);
			}
		});
	});
}


var sectionId = window.location.hash,
	section = sectionId ? document.querySelector(sectionId) : false;

if(sectionId && !section) {
	var lowerId = sectionId.split('#')[1].toLowerCase();

	[].slice.call(document.querySelectorAll('*[id]')).forEach(function(el) {
		if(el.id.toLowerCase() == lowerId) {
			section = el;
		}
	});
}

if(section) {
	setTimeout(function() {
		scrollToElement(section);
	}, 300);

	if(
		(section.parentNode.classList.contains('accordion') || section.id.indexOf('accordion') > -1) &&
		!section.closest('.accordion-locations')
	) {
		var openAccordion = section.parentNode.querySelector('button.open');

		if(openAccordion) {
			Velocity(openAccordion.nextElementSibling, 'slideDown', {duration: 250});
			openAccordion.classList.remove('open');
			openAccordion.setAttribute('aria-expanded', 'true');
		}

		setTimeout(function() {
			Velocity(section.querySelector('.answer'), 'slideDown', {duration: 250});

			var button = section.querySelector('button');

			button.classList.add('open');

			button.setAttribute('aria-expanded', 'true');
		}, 1200);
	}
}

/*=============================
=         Element Link        =
=============================*/

var links = [].slice.call(document.querySelectorAll('.link'));

links.forEach(function(link) {
	link.addEventListener('click', function(e) {
		if(e.target.tagName !== 'A' && this.hasAttribute('data-href'))
			goToLink(this.dataset.href);
	});
});

function goToLink(href) {
	if(href.indexOf(location.host) == -1)
		window.open(href);
	else
		window.location.href = href;
}

/*=============================
=        Vertical Icons       =
=============================*/

var interval = 0,
	icons = document.querySelectorAll('section.vertical_icons .icons-list li, body#what-to-expect #hero.simple ol li');

if(icons.length)
	for(var i=0; i<icons.length; i++)
		iconWaypointFunc(icons[i]);

function iconWaypointFunc(icon) {
	var firstIcon = icon.parentNode.querySelector('li'),
		iconWaypoint = new Waypoint({
		element: icon,
		handler: function(direction) {
			if(direction == 'down') {
				var sibling = icon.previousElementSibling;

				setTimeout(function() {
					if(sibling)
						sibling.classList.add('show-line');

					icon.classList.add('current');

					interval = 0;
				}, (interval++*1300));

				this.destroy();
			}
		},
		offset: firstIcon.getBoundingClientRect().top < window.innerHeight ? (firstIcon.getBoundingClientRect().top - (icon == firstIcon ? 10 : 0)) : '90%'
	});
}

/*=============================
=            Slider           =
=============================*/

import Vue from 'vue';
import SlickSlider from './vue/slider/SlickSlider';

[].slice.call(document.querySelectorAll('section[class*="_slider"], section.treatment_cards, section.experts.mobile-slider, section.experts_alt.mobile-slider, body.symptom #hero, section.reviews_carousel, .images_slider, section.info_cards')).forEach(function(section) {
	var slider = section.querySelector('.slider-container');

	var sliderApp = new Vue({
		el: slider,
		components: { SlickSlider }
	});
});

var doubleS = document.getElementById('mobile-slider');

if(doubleS) {
	var sliderApp = new Vue({
		el: document.getElementById('mobile-slider'),
		components: { SlickSlider }
	});
}

/*=============================
=           Trustlogos        =
=============================*/

var trustlogosTopInterval,
	trustlogosBottomInterval,
	insuranceInterval;

[].slice.call(document.querySelectorAll('section.trustlogos:not(.no-rotate):not(#static-mobile), section.insurance')).forEach(function(section) {
	var logosContainer = section.querySelector(
		section.classList.contains('trustlogos')
			? '.trustlogos-container'
			: '.insurance-list'
	);

	if(checkWidth(480) || body.classList.contains('location-new')) {
		trustlogosWaypointFunction(section, logosContainer);
	}
});

function clearTrustlogoInterval(section) {
	if(section.classList.contains('center'))
		clearInterval(trustlogosTopInterval);
	else if(section.classList.contains('left'))
		clearInterval(trustlogosBottomInterval);
	else if(section.classList.contains('insurance'))
		clearInterval(insuranceInterval);
}

function trustlogosWaypointFunction(section, logosContainer) {
	if (body.classList.contains('location-new')) {
		logosContainer.querySelectorAll('img').forEach(function(img) {
			img.classList.add('not-lazy');

			if (img.dataset.src && !img.src) {
				img.src = img.dataset.src;
			}
		});
	}

	var handlerCall = function() {
		var autoSlideLogos = function() {
			try {
				slideLogo(logosContainer, 'next', section);
			} catch(e) {
				console.error('SLIDE ERROR', e);
			}
		};

		if(section.classList.contains('center')) {
			trustlogosTopInterval = setInterval(autoSlideLogos, 1000);
		}
		else if(section.classList.contains('left')) {
			trustlogosBottomInterval = setInterval(autoSlideLogos, 1000);
		}
		else if(section.classList.contains('insurance')) {
			insuranceInterval = setInterval(autoSlideLogos, 1000);
		}
	};

	var rect = section.getBoundingClientRect();

	if (rect.top < window.innerHeight && rect.bottom > 0) {
		requestAnimationFrame(function() { handlerCall(); });
		return;
	}

	var trustlogosWaypoint = new Waypoint({
		element: section,
		handler: handlerCall,
		offset:
			checkWidth(480) &&
			window.innerHeight > 552 &&
			logosContainer.classList.contains('first')
				? '80%'
				: '95%'
	});
}

function slideLogo(trustlogosContainer, direction, section) {
	var trustlogos = trustlogosContainer.querySelectorAll('figure'),
		trustlogosCount = trustlogos.length;

	if (section && body.classList.contains('location-new')) {
		var track = trustlogosContainer;

		if (!track.dataset.init) {
			track.innerHTML += track.innerHTML;
			track.dataset.init = "1";
			track.style.willChange = "transform";
			track.style.transform = "translate3d(0,0,0)";
		}

		if (track.dataset.running) return;

		track.dataset.running = "1";

		track.classList.add('revealed');

		var width = 0;
		var x = 0;
		var speed = 1;

		function tick() {
			x -= speed;

			if (!width) {
				width = track.scrollWidth / 2;
				track._width = width;
			}

			if (width && x <= -width) x += width;

			track.style.transform = 'translate3d(' + x + 'px, 0, 0)';

			requestAnimationFrame(tick);
		}

		tick();

		return;
	}

	var trustlogosPos = trustlogosContainer.getBoundingClientRect().left,
		gap = parseInt(window.getComputedStyle(trustlogos[0]).marginRight);

	for (var i = 0; i < trustlogosCount; i++) {

		var figure = trustlogos[i];

		if (trustlogosPos == Math.round(figure.getBoundingClientRect().left)) {

			var clone,
				trustlogo = trustlogos[(direction == 'next' ? i : (i - 1))],
				slideTo = direction == 'next'
					? '-' + (figure.offsetWidth + gap) + 'px'
					: 0;

			if (i === 0 && direction == 'prev') {
				clone = trustlogos[trustlogosCount - 1].cloneNode(true);

				clone.style.marginLeft =
					'-' + (trustlogos[trustlogosCount - 1].offsetWidth + gap) + 'px';

				trustlogosContainer.prepend(clone);

				trustlogo = trustlogosContainer.querySelector('figure');

				trustlogos[trustlogosCount - 1].remove();
			}

			if ((i + 3) == trustlogosCount && direction == 'next') {
				clone = trustlogos[0].cloneNode(true);

				clone.style = '';

				trustlogosContainer.append(clone);

				trustlogos[0].remove();
			}

			Velocity(
				trustlogo,
				{ marginLeft: [slideTo, 'linear'] },
				{ duration: 1000 }
			);

			break;
		}
	}
}

/*=============================
=         Form Process        =
=============================*/

var expect = document.querySelector('#what-to-expect'),
	headerHeightOffset = header.offsetHeight,
	newsletterSection = document.getElementById('newsletter');

[].slice.call(document.querySelectorAll('.ajax-form')).forEach(function(form) {
	form.addEventListener('submit', formProcess);
});

function formProcess(e) {
	if('performance' in window === false)
		return true;

	e.preventDefault();

	var form = this,
		isNewsletter = form.id == 'newsletter-form',
		section = isNewsletter ? newsletterSection : (form.id == 'landing-form-footer' ? document.getElementById('footer-form') : hero),
		data = new FormData(form),
		button = this.querySelector('button[type="submit"]');

	form.reportValidity();

	if(!form.checkValidity()) {
		return false;
	}

	button.classList.add('disabled');

	// Unused
	// data.append('c_time', performance.now() >= 7000 ? 0 : 1);

	// Add nl_signup to FormData if checkbox is unchecked
	if(!data.get('nl_signup') && !isNewsletter) {
		data.append('nl_signup', 0);
	}

	// Sanitize Phone
	var phone = data.get('phone');

	if(phone) {
		data.set('phone', '1'+phone.replace(/-/g, '').replace(/\(|\)/g,'').replace(/\s/g, ''));
	}

	axios.post(form.action, data)
		.then(function(r) {
			if(r.data.notSpam) {
				var formData = {},
					segmentEvent = '';

				if(isNewsletter) {
					formData = {
						email: data.get('email')
					};

					segmentEvent = 'newsletter_submitted';
				} else {
					formData = {
						first_name: data.get('first_name'),
						last_name: data.get('last_name'),
						email: data.get('email'),
						phone: data.get('phone'),
						nl_signup: data.get('nl_signup'),
						is_spam: false, // Value is always false since tracking is only sent if not spam
						action_source: 'website' // Segment
					};

					segmentEvent = 'form_submitted';
				}

				segmentTracking(segmentEvent, formData);

				if(typeof dataLayer !== 'undefined') {
					const dataLayerObj = {
						'event': 'FormSubmission',
						'form': (isNewsletter ? ((isSpanish ? 'es/' : '') + 'newsletter') : window.location.pathname.substring(1))
					};

					dataLayer.push({...dataLayerObj, ...formData});
				}
			}

			section.classList.add('hidden');

			if (document.querySelector('body.landing')) {
				form.querySelectorAll('input').forEach(input => {
					input.value = '';
				});
			}

			if (document.querySelector('body:not(.landing)')) {
				setTimeout(function() {
					section.querySelector('.container').innerHTML = r.data.message;
					section.classList.remove('hidden');

					if(isNewsletter) {
						switchNewsletterBg();
					}
					else {
						section.querySelector('.container').classList.remove('left');

						if(checkWidth(768)) {
							Velocity(section, 'scroll', {
								duration: 1000,
								delay: 250,
								offset: -headerHeightOffset
							});
						}

						if(expect)
							expect.style.display = 'block';
					}
				}, 500);
			}

			setTimeout(function() {
				if(document.querySelector('body.landing')) {
					window.location.href = isSpanish ? '/es/consult' : '/consult';
				}
			}, 500);
		})
		.catch(function (e) {
			setTimeout(function() {
				button.classList.remove('disabled');
			}, 500);

			console.log(e.response.data.errors);

			var formMessage = form.previousElementSibling;

			formMessage.classList.add('error');
			formMessage.innerHTML = e.response.data.message;

			if(e.response.status===422) {
				clearErrors(form);
				setErrors(form, e.response.data.errors);
			}
		});
}

function clearErrors(form) {
	var errors = form.getElementsByClassName('error');

	for(var e=errors.length - 1; e>=0; e--)
		errors[e].classList.remove('error');

	// Velocity(formMessage, 'scroll', {
	// 	duration: 500,
	// 	offset: -1 * (header.offsetHeight + 50)
	// });
}

function setErrors(form, errors) {
	for(var key in errors) {
		var label = form.querySelector(form.id == 'newsletter-form' ? ('#'+key) : 'label[for="'+key+'"]');

		if(label)
			label.parentNode.classList.add('error');

		if(key == 'g-recaptcha-response')
			document.querySelector('.g-recaptcha').classList.add('error');
	}
}

// Redirect if consult form or location page
document.addEventListener('dataLayerPushed', function() {
	console.log("TEST")
	if(body.id === 'consult' || body.classList.contains('location-new')) {
		const isSpanish = body.classList.contains('es');

		window.location.href = (isSpanish ? '/es' : '') + '/consult/confirm';
	}
});

window.hubspotFormSubmit = function hubspotFormSubmit(footer) {
	if (footer && !body.classList.contains('location-new')) {
		var form = document.querySelector('#footer-form .hbspt-form');
		var formText = document.querySelector('#footer-form .text-container');
		var thankYou = document.querySelector('#footer-form .form-submission');

		Velocity(form, 'slideUp', {
			duration: 500,
			display: 'none',
			complete: function () {
				thankYou.hidden = false;
				formText.hidden = true;
				Velocity(thankYou, 'slideDown', { duration: 400 });
			}
		});
	} else {
		hero.querySelectorAll('.form-container .tab-content > h2, .form-container .tab-content > p').forEach(function(el) {
			Velocity(el, 'slideUp', { duration: 500, display: 'none' });
		});
	}
};

var hsFooterCheckbox = document.querySelector('#footer-form .hs-form-booleancheckbox');

window.switchNewsletterBg = function switchNewsletterBg() {
	newsletterSection.querySelector('.bg-container:nth-child(1)').style.display = 'none';
	newsletterSection.querySelector('.bg-container:nth-child(2)').style.display = 'block';
	bgLazyLoad(newsletterSection.querySelector('.bg-container:nth-child(2)'));

	if(window.hbspt) {
		newsletterSection.querySelectorAll('.container > .title, .container > p').forEach(function(el) {
			Velocity(el, 'slideUp', {duration: 500, display: 'none'});
		});
	}
};

/*=============================
=             Modal           =
=============================*/

var modals = [].slice.call(document.querySelectorAll('div[role="dialog"]')),
	ieModal = document.getElementById('ie-modal');

modals.forEach(function(modal) {
	modal.addEventListener('click', function(e) {
		if(e.target == modal.querySelector('button') || !modal.querySelector('.content').contains(e.target))
			closeModal();
	});
});

function closeModal() {
	modals.forEach(function(modal) {
		if(window.getComputedStyle(modal).display == 'block')
			Velocity(modal, {opacity: [0,1]}, {duration: 300, display: 'none'});

		if(modal == videoModal) {
			setTimeout(function() {
				videoIframe.src = 'about:blank';
				skipLinkToggleDisplay(false);
				setFocus(false, false);
			}, 300);
		}
	});
}

document.addEventListener('keydown', function(e) {
	if(e.key == 'Escape')
		closeModal();
});

if(ieModal) {
	ieModal.querySelector('.close-modal').focus();
	skipLinkToggleDisplay(true);
	setFocus(true, false);
}

/*=============================
=             Video           =
=============================*/

window.videoButtonClick = function videoButtonClick(event) {
	event.preventDefault();

	var parent = this.parentNode.parentNode,
		thumbnail = parent.querySelector('.thumbnail'),
		video = parent.querySelector('figure.video > *:first-child');

	if(thumbnail)
		Velocity(thumbnail, {opacity: [0,1]}, {duration: 150, display: 'none'});

	video.addEventListener('play', function(event) {
		event.preventDefault();

		let videoParent = this.parentNode;

		if(videoParent.classList.contains('video-paused')) {
			videoParent.classList.remove('video-paused')
		}
	});

	video.addEventListener('pause', function(event) {
		event.preventDefault();

		let videoParent = this.parentNode;

		if(!videoParent.classList.contains('video-paused')) {
			videoParent.classList.add('video-paused')
		}
	});

	playVideo(video);
};

var videoButtons = [].slice.call(document.querySelectorAll('.video-container button'));

videoButtons.forEach(function(videoButton) {
	videoButton.addEventListener('click', videoButtonClick);
});

function playVideo(video) {
	video.src = video.dataset.src;

	if(video.tagName === 'VIDEO')
		video.autoplay = true;
}

function resetVideo(video) {
	var src = video.src;
	video.src = src.replace('?autoplay=1&rel=0', '');
}

/*=============================
=            Search           =
=============================*/

// [].slice.call(document.querySelectorAll('form.site-search')).forEach(function(search) {
// 	search.addEventListener('submit', function(e) {
// 		e.preventDefault();

// 		var input = this.querySelector('input');

// 		if(input.value !== '')
// 			window.location.href = '/search?q='+input.value+'#search-results';
// 		else
// 			input.classList.add('error');
// 	});
// });

/*=============================
=      Load 3rd Party JS      =
=============================*/

// var js = [
// 	''
// ];

// setTimeout(function() {
// 	js.forEach(function(src) {
// 		if(document.querySelector('body:not(.landing)')) {
// 			addJS(src);
// 		}
// 	});
// }, 5000);

/*=============================
=           Big Cards         =
=============================*/

[].slice.call(document.querySelectorAll('section.big_cards li.card')).forEach(function(card) {
	card.addEventListener('click', function() {
		var link = card.querySelector('a');

		if(link)
			goToLink(link.href);
	});
});

/*=============================
=   Segment - Inbound Calls   =
=============================*/

document.addEventListener('click', function(event) {
	var telLink = event.target.closest('a[href^="tel"');

	if(telLink) {
		var parentContainer = telLink.parentNode;
		var results = null;

		results = parentContainer.textContent.trim();

		var callPurpose = null;
		var isPrivacyPolicy = false;
		var hrefValue = telLink.getAttribute('href');

		if(window.location.pathname == '/privacy-policy' || window.location.pathname == 'es/privacy-policy') {
			isPrivacyPolicy = true;
		} else {
			isPrivacyPolicy = false;
		}

		if((hrefValue === 'tel:888-660-3494' || hrefValue == 'tel:8665012387' || hrefValue == 'tel:866-501-2387' || hrefValue == 'tel:8664321968') && isPrivacyPolicy == false) {
			callPurpose = 'Book a Free Evaluation';
		} else if((hrefValue === 'tel:888-660-3494' || hrefValue == 'tel:8665012387' || hrefValue == 'tel:866-501-2387') && isPrivacyPolicy == true) {
			callPurpose = 'Privacy Policy Questions';
		} else if( hrefValue == 'tel:866-511-6877' || hrefValue == 'tel:8665116877') {
			callPurpose = 'Billing Questions';
		} else if( hrefValue == 'tel:866-932-1217' || hrefValue == 'tel:8669321217') {
			callPurpose = 'Insurance Questions';
		} else {
			callPurpose = 'Book a Free Evaluation';
		}

		var phoneData = {
			inbound_phone_number: telLink.getAttribute('href').replace('tel:',''),
			call_purpose: callPurpose,
			CTA: results,
			action_source: 'website'
		};

		segmentTracking('inbound_call_started', phoneData);
	}
})

/*=============================
=   Segment - analytics.page  =
=============================*/

var tracking = getTrackingParameters();

analytics.page(tracking, { anonymousId: Cookie.get('segment_anonymousId') });

document.addEventListener('click', (e) => {
	if (!e.target.matches('.form-tabs .tab')) return;

	const tab = e.target;
	const container = tab.closest('.form-container');

	container.querySelectorAll('.tab').forEach(t => t.classList.remove('active'));
	tab.classList.add('active');

	const target = tab.dataset.tab;

	container.querySelectorAll('.tab-content').forEach(c => {
		c.classList.remove('active');

		if (c.dataset.content === target) {
			c.classList.add('active');
		}
	});
});

/*=============================
=        What to Expect       =
=============================*/

function syncHeights() {
	const section = document.querySelector('section.what_to_expect .desktop-layout');

	if (!section) return;

	const ul = section.querySelector('.next-steps ul');
	const text = section.querySelector('.media-text .text-container');

	if (!ul || !text) return;

	text.style.height = ul.offsetHeight + 'px';

	section.closest('section.what_to_expect')?.classList.add('loaded');
}

syncHeights();
window.addEventListener('resize', syncHeights);

var interval = 0,
	icons = document.querySelectorAll('section.what_to_expect .next-steps ul li');

if(icons.length)
	for(var i=0; i<icons.length; i++)
		iconWaypointFunc(icons[i]);

function initHeroVideoTitleToggle() {
	if (!document.body || !document.body.classList.contains('contact')) return;

	if (window.innerWidth <= 1023) return;

	const container = document.querySelector('.hero-video-container');
	if (!container) return;

	const video = container.querySelector('video');
	if (!video) return;

	const titles = document.querySelectorAll('[class^="video-title"], [class*=" video-title"]');

	function hideTitles() {
		titles.forEach(el => {
			el.style.opacity = 0;
			el.style.pointerEvents = 'none';
		});
	}

	video.addEventListener('play', hideTitles);

	if (!video.paused) {
		hideTitles();
	}
}

initHeroVideoTitleToggle();

document.querySelectorAll('.badge-text').forEach(container => {
	const lines = container.querySelectorAll('p');

	if (lines.length === 0) return;

	const setWidth = (el) => {
		const width = el.getBoundingClientRect().width;
		container.style.width = width + 'px';
	};

	if (lines.length === 1) {
		lines[0].classList.add('active');

		document.fonts.ready.then(() => {
			requestAnimationFrame(() => {
				setWidth(lines[0]);
			});
		});

		return;
	}

	let index = 0;

	lines.forEach((line, i) => {
		line.classList.toggle('active', i === 0);
	});

	document.fonts.ready.then(() => {
		requestAnimationFrame(() => {
			setWidth(lines[0]);
		});
	});

	setInterval(() => {
		lines[index].classList.remove('active');

		index = (index + 1) % lines.length;

		const next = lines[index];
		next.classList.add('active');

		requestAnimationFrame(() => {
			setWidth(next);
		});

	}, 2500);
});

/*=============================
=       Location Sidebar      =
=============================*/

document.querySelectorAll(
	'section.location_about .physician-content, section.location_about .iac-content, section.location_about .text-container'
).forEach(container => {

	const readMoreButtons = container.querySelectorAll('.read-more');

	if (!readMoreButtons.length) return;

	readMoreButtons.forEach(readMore => {

		readMore.addEventListener('click', function(e) {
			e.preventDefault();

			if (container.classList.contains('open')) {
				container.classList.remove('open');

				readMoreButtons.forEach(button => {
					button.innerHTML = 'Read More';
				});
			} else {

				document.querySelectorAll(
					'section.location_about .physician-content.open, section.location_about .iac-content.open'
				).forEach(openCard => {
					openCard.classList.remove('open');

					openCard.querySelectorAll('.read-more').forEach(button => {
						button.innerHTML = 'Read More';
					});
				});

				container.classList.add('open');

				readMoreButtons.forEach(button => {
					button.innerHTML = 'Read Less';
				});
			}
		});

	});

});

function openCard(container) {
	container.style.height = container.offsetHeight + 'px';

	container.classList.add('open');

	requestAnimationFrame(() => {
		container.style.height = container.scrollHeight + 'px';
	});

	container.addEventListener('transitionend', function handler(e) {
		if (e.propertyName !== 'height') return;

		container.style.height = 'auto';
		container.removeEventListener('transitionend', handler);
	});
}

function closeCard(container) {
	container.style.height = container.scrollHeight + 'px';

	requestAnimationFrame(() => {
		container.style.height = container.scrollHeight + 'px';

		requestAnimationFrame(() => {
			container.classList.remove('open');

			container.querySelector('.read-more').innerHTML = 'Read More';

			requestAnimationFrame(() => {
				container.style.height = container.scrollHeight + 'px';
			});
		});
	});

	container.addEventListener('transitionend', function handler(e) {
		if (e.propertyName !== 'height') return;

		container.style.height = '';
		container.removeEventListener('transitionend', handler);
	});
}

/*=============================
=     Location About Text     =
=============================*/

const locationText = document.querySelectorAll('section.location_about .text-container p');

let textIndex = 0;

locationText.forEach(text => {
	if (textIndex > 0) {
		text.classList.add('hide');
	}

	textIndex = textIndex + 1;
});